export const DEFAULT_CHAT_TIMEZONE = 'America/Los_Angeles'

// Chat requests cross an untrusted JSON boundary. Keep only timezone identifiers supported by the
// runtime and fall back predictably when an older client (or an automatic follow-up) sends none.
export function normalizeChatTimezone(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return DEFAULT_CHAT_TIMEZONE
  const timezone = value.trim()
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: timezone }).format(new Date(0))
    return timezone
  } catch {
    return DEFAULT_CHAT_TIMEZONE
  }
}

export function currentChatTimezone(): string {
  return normalizeChatTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)
}
